import React, { useContext, useEffect, useRef } from "react";
import { List, ListItem, Box, CircularProgress } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { VehicleAvatar, LegalEntityAvatar, Tag, VehicleInstalledTermometer, VehicleInstalledAnalysis } from "../Snippet";
import { VehicleKilometer } from "../Chart";
import { Icon } from "../../assets";
import { useDrawer } from "../Drawer";
import { useDataProvider } from '../../../mtska-frontend-data-provider';
import { useFormatter } from "src/mtska-frontend-app-component/utils";
import { Text } from "../Typography";
import { AppContext } from "src/mtska-frontend-app-scaffolding";

const InfoHeaderVehicleSeller = ({ view, item, hideContractBox = false }) => {
    const { t } = useTranslation();
    const { activate } = useDrawer();
    const { formatDate, formatDistance, formatCurrency } = useFormatter();
    const { userCapabilities, user } = useContext(AppContext);

    const { loadOne } = useDataProvider('cars/car');
    const handleRefineContract = () => {
        !userCapabilities['auth/role.is_driver'] && activate('contracts/detail', {
            id: item?.contract?._id,
            defaultValue: item?.contract,
            filters: item?.contract,
        }, () => loadOne(item?._id));
    };

    const handleAssociateContract = () => {
        activate('cars/contractAssociation', {
            id: item?._id,
            defaultValue: item,
            filters: item,
        });
    };

    const handleCheckProduction = () => {
        activate('cars/productionCheck', {
            item: item
        });
    };


    const tracingSerie = useRef();
    const tracingSerieRedraw = useRef(0);
    useEffect(() => {
        if (!item) return;
        if (item.traceKms != tracingSerie.current) {
            tracingSerie.current = item.traceKms
            tracingSerieRedraw.current = tracingSerieRedraw.current + 1
        }
    }, [item])

    const accountName = item?.contract?.account?.person?.firstname && item?.contract?.account?.person?.lastname
        ? `${item.contract.account.person.firstname} ${item.contract.account.person.lastname}`
        : null;
    const contractEndAt = (() => {
        if (item?.contract?.end_at) return item.contract.end_at;
        if (!item?.contract?.start_at || !item?.contract?.contractDuration) return null;

        const endAt = new Date(item.contract.start_at);
        endAt.setMonth(endAt.getMonth() + parseInt(item.contract.contractDuration, 10));
        endAt.setDate(endAt.getDate() - 1);

        return endAt;
    })();

    return (
        <Box className={"info-header info-header-" + view + ' info-header-sales'}>
            <VehicleAvatar size="big" url={item?.picture?.url} item={item} />
            <Box className={"info-wrapper"}>
                <Box className="info-summary-external">
                    <LegalEntityAvatar name={item?.legalEntity?.name} url={item?.legalEntity?.logo?.url} size="small" withname={true} />

                    {
                        item?.legalEntity?.owner && (
                            <Text icon="faUserTie" className="info-contract">{item?.legalEntity?.owner}</Text>
                        )
                    }

                </Box>

                <Box className="info-name">
                    <span className="primary">{item?.setup?.make ?? t('Unknown make, model, setup')} {item?.setup?.model}</span><span className="secondary" title={item?.setup?.setup}>{item?.setup?.setup}</span>
                </Box>
                <Box className="info-summary-external">
                    {
                        item?.contract && (
                            <LegalEntityAvatar name={item?.contract?.renter?.name} url={item?.contract?.renter?.logo?.url} size="small" withname={true} />
                        )
                    }

                    {
                        item?.contract?.totalLeaseFee && (
                            <Text icon="faMoneyBill" className="info-contract">{formatCurrency(item?.contract?.totalLeaseFee)}</Text>
                        )
                    }

                    {
                        item?.contract?.contractMileage && (
                            <Text icon="faRoad" className="info-contract">{formatDistance(item?.contract?.contractMileage)}</Text>
                        )
                    }

                    {
                        item?.contract?.contractDuration && (
                            <Text icon="faHourglass" className="info-contract">{item?.contract?.contractDuration} {t('months')}</Text>
                        )
                    }

                    {
                        item?.contract?.start_at && (
                            <Text icon="faArrowRightFromLine" className="info-contract">{formatDate(item?.contract?.start_at)}</Text>
                        )
                    }

                    {
                        contractEndAt && (
                            <Text icon="faArrowRightToLine" className="info-contract">{formatDate(contractEndAt)}</Text>
                        )
                    }

                </Box>
                <List className="info-details">
                    <ListItem>
                        <span className="key">{t('plate')}</span>
                        <span className="value">{item?.plate || (<Tag color={"warning"} title={t("No plate yet assigned")}><Icon icon="faWarning" />{t('No plate yet assigned')}</Tag>)}</span>
                    </ListItem>

                    {
                        user?.roles?.includes('backoffice') && (
                            <ListItem>
                                <span className="key">{t('orderSentToRenter_at')}</span>
                                <span className="value">{formatDate(item?.contract?.orderSentToRenter_at)}</span>
                            </ListItem>
                        )
                    }


                    {/* {
                        !userCapabilities['auth/role.is_driver'] && (
                            <ListItem>
                                <span className="key">{t('production')}</span>
                                <span className="value">
                                    {!item?.contract?.production?.renter && !item?.contract?.production?.dealer && !item?.contract?.production?.oem ? (
                                        <Tag color={"warning"} title={t("Missing contract's production")} onClick={item?.contract ? handleCheckProduction : handleAssociateContract}>
                                            <Icon icon="faArrowTrendUp" />
                                            {t('Check')}
                                        </Tag>
                                    ) : (
                                        <>
                                            {item?.contract?.production?.renter !== undefined && (
                                                <Tag style={{ minWidth: '48px', display: "flex", userSelect: 'none' }} title={t("Renter's production")} color={item?.contract?.production?.renter ? "success" : "warning"}
                                                    onClick={item?.contract?.production?.renter === null ? (item?.contract ? handleCheckProduction : handleAssociateContract) : undefined}>

                                                    <em style={{ flex: 1, fontStyle: 'normal' }}>R</em> <strong style={{ flex: 1, textAlign: 'center' }}>{item?.contract?.production?.renter !== null ? item?.contract?.production?.renter : '-'}</strong>
                                                </Tag>
                                            )}
                                            {item?.contract?.production?.dealer !== undefined && (
                                                <Tag style={{ minWidth: '48px', display: "flex", userSelect: 'none' }} title={t("Dealer's production")} color={item?.contract?.production?.dealer ? "success" : "warning"}
                                                    onClick={item?.contract?.production?.dealer === null ? (item?.contract ? handleCheckProduction : handleAssociateContract) : undefined}>

                                                    <em style={{ flex: 1, fontStyle: 'normal' }}>D</em> <strong style={{ flex: 1, textAlign: 'center' }}>{item?.contract?.production?.dealer !== null ? item?.contract?.production?.dealer : '-'}</strong>
                                                </Tag>
                                            )}
                                            {item?.contract?.production?.oem !== undefined && (
                                                <Tag style={{ minWidth: '48px', display: "flex", userSelect: 'none' }} title={t("OEM's production")} color={item?.contract?.production?.oem !== null ? "success" : "warning"}
                                                    onClick={item?.contract?.production?.oem === null ? (item?.contract ? handleCheckProduction : handleAssociateContract) : undefined}>

                                                    <em style={{ flex: 1, fontStyle: 'normal' }}>O</em> <strong style={{ flex: 1, textAlign: 'center' }}>{item?.contract?.production?.oem !== null ? item?.contract?.production?.oem : '-'}</strong>
                                                </Tag>
                                            )}
                                        </>
                                    )}
                                </span>
                            </ListItem>
                        )
                    } */}
                    <ListItem>
                        <span className="key">{t('status')}</span>
                        <Box className="value">
                            {
                                item?.status ? (<Tag color={"secondary"} size="small" label={t(item?.status)} />) : (<Tag color={"danger"} title={t("Missing vehicle status")}><Icon icon="faWarning" />{t('Missing')}</Tag>)
                            }
                        </Box>
                    </ListItem>

                    <ListItem>
                        <span className="key">{t('IDPartner')}</span>
                        <span className="value">{item?.contract?.IDPartner}</span>
                    </ListItem>
                </List>
            </Box>
            {/* 
            contractStartDate={item?.contract?.start_at}<br/>
            contractEndDate={item?.contract?.end_at}<br/>
            contractTotalKM={item?.contract?.contractMileage}<br/>
            lastTraceKMValue={item?.lastTraceKMValue}<br/>
            lastTraceKMDate={item?.lastTraceKMDate}<br/>
            contractCostKMExcess={item?.contract?.bracket1ExtraKmCost}<br/>
            contractMonths={item?.contract?.contractDuration}
             */}
            {
                (!hideContractBox && item?.contract && item?.contract?.start_at && contractEndAt) && (
                    <>
                        <VehicleInstalledTermometer
                            item={item}
                            contractStartDate={item?.contract?.start_at}
                            contractEndDate={contractEndAt}
                            contractMonths={item?.contract?.contractDuration}
                            contractInitialKM={item?.contract?.initialMileage}
                            contractTotalKM={item?.contract?.contractMileage}
                            lastTraceKMValue={item?.traceKmsLast?.value}
                            lastTraceKMDate={item?.traceKmsLast?.traced_at}
                            layout="aside"
                        />
                        <VehicleKilometer
                            item={item}
                            contractStartDate={item?.contract?.start_at}
                            contractEndDate={contractEndAt}
                            contractMonths={item?.contract?.contractDuration}
                            contractKilometers={item?.contract?.contractMileage}
                            contractCostKMExcess={item?.contract?.bracket1ExtraKmCost}
                            contractKMReimbursement={item?.contract?.bracket1KmReimbursement}
                            contractPercentage1={item?.contract?.bracket1Percentage}
                            contractCostKMExcess2={item?.contract?.bracket2ExtraKmCost}
                            contractKMReimbursement2={item?.contract?.bracket2KmReimbursement}
                            contractPercentage2={item?.contract?.bracket2Percentage}
                            contractCostKMExcess3={item?.contract?.bracket3ExtraKmCost}
                            contractKMReimbursement3={item?.contract?.bracket3KmReimbursement}
                            contractPercentage3={item?.contract?.bracket3Percentage}
                            contractCostKMCurrency={'EUR'}
                            contractKmDeductible={item?.contract?.contractKmDeductible}
                            contractInitialMileage={item?.contract?.initialMileage}
                            contractMaxReimbursementAmount={item?.contract?.maxReimbursementAmount}
                            tracingSerie={tracingSerie.current}
                            tracingSerieRedraw={tracingSerieRedraw.current}
                        />
                    </>
                )
            }
            {
                item?.analysis && <VehicleInstalledAnalysis analysis={item?.analysis} car_id={item?._id} />
            }
        </Box>
    )
}

export default InfoHeaderVehicleSeller;